'use strict';

/**
 * Фиксированный хедер с функцией сворчанивания при скроле
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-navpanel"]- поиск элементов по селектору
 * @sourceCode
 */
(function ($) {
	// set scrolling variables
	let scrolling = false;
	let previousTop = 0;
	let scrollDelta = 5;
	let scrollOffset = 100;
	let $selector = $('.js-navpanel');
	let $body = $('body');
	let $window = $(window);

	$window.on('scroll', function () {
		if (!scrolling) {
			scrolling = true;
			(!window.requestAnimationFrame)
				? setTimeout(autoHideHeader, 250)
				: window.requestAnimationFrame(autoHideHeader);
		}
	});

	function autoHideHeader () {
		let currentTop = $window.scrollTop();

		checkSimpleNavigation(currentTop);

		previousTop = currentTop;
		scrolling = false;
	}

	function checkSimpleNavigation (currentTop) {
		if (previousTop - currentTop > scrollDelta) {
			$selector.removeClass('is-hidden');
			$body.addClass('show-header');
		} else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
			$selector.addClass('is-hidden');
			$body.addClass('show-w');
			$body.removeClass('show-header');
		}

		if (currentTop < scrollOffset) {
			$body.removeClass('show-header show-w');
		}
	}
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/navpanel.js